module.exports = __webpack_public_path__ + "static/img/apartmentselvira.dbdbfd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/apartmentselvira.png
// module id = FFPe
// module chunks = 0